module.exports = __webpack_public_path__ + "static/media/slakteweb-icon-white@2x.ba44e9ad.png";